import HttpReference from '../platform/HttpReference';
import AcceptQuote from './DispatchAcceptQuote';

export default class Quote extends HttpReference {
  constructor(path, parent) {
    super(path, parent);

    this.accept = new AcceptQuote('accept', this);
  }
}
